module.exports = __webpack_public_path__ + "media/images/menu/cetus-9bd897fb5d77d02da9a9461475c0552e.jpg";